<template>
  <div>
    <FimButton
      type="raw"
      no-padding
      is-small
      data-tracking-label="Filterkategorie - Info"
      class="text-sm"
      @click="openOverlay"
    >
      <template #icon>
        <LazyIconFielmannInfoCircle class="size-4" />
      </template>
      {{ $t('filter.more_info') }}
    </FimButton>
  </div>
  <MultipleSelectionList
    v-model="value"
    :items="filter.values"
    class="mt-2 space-y-2"
    tag="ul"
  >
    <template #item="{ item }: { item: any }">
      <li class="mb-[5px]">
        <Checkbox
          :id="filter.slug + '-' + item.value"
          v-model="value"
          :item="item"
          text-size="md"
        >
          <template #label>
            <span class="tabular-nums">{{ item.displayName }}</span>
          </template>
          <template #icon>
            <div class="relative mr-2">
              <div
                class="absolute inset-0 rounded-full bg-black"
                :style="{
                  opacity: 0.1 + 0.1 * parseInt(item.handle),
                }"
              ></div>
              <LazyIconFielmannEye class="size-6 p-0.5" />
            </div>
          </template>
        </Checkbox>
      </li>
    </template>
  </MultipleSelectionList>
  <Overlay
    :open="isFilterInfoOpen"
    portal-target="body"
    @update:open="isFilterInfoOpen = $event"
  >
    <template #title>
      <Headline tag="h2" look="h4" weight="medium">
        {{ filter.name }}
      </Headline>
    </template>
    <table class="w-full rounded-2xl bg-gray-150 text-sm">
      <thead>
        <tr>
          <th :class="cellClasses">
            <div>{{ filter.name }}</div>
            <div class="font-normal">DIN EN ISO 12312-1</div>
          </th>
          <th :class="cellClasses">{{ $t(`${i18nRoot}.column_tint`) }}</th>
          <th :class="cellClasses">
            {{ $t(`${i18nRoot}.column_application`) }}
          </th>
        </tr>
      </thead>
      <tbody>
        <template v-for="item in infoTable" :key="item.cat">
          <tr>
            <th :class="cellClasses">{{ item.cat }}</th>
            <th :class="cellClasses">{{ item.tint }}</th>
            <td :class="cellClasses">{{ item.application }}</td>
          </tr>
          <tr v-if="item?.warning">
            <td :class="cellClasses" colspan="3">{{ item.warning }}</td>
          </tr>
        </template>
      </tbody>
    </table>
  </Overlay>
</template>

<script setup lang="ts">
const props = defineProps<{
  modelValue: any
  filter: any
}>()

const emit = defineEmits(['update:model-value'])

const value = computed({
  get: () => props.modelValue,
  set: (newValue: any) => {
    emit('update:model-value', newValue)
  },
})

const $i18n = useI18n()
const i18nRoot = 'filter.filterCategory'

/** overlay */

const { trackButtonClick } = await useTrackingEvents()
const isFilterInfoOpen = ref(false)

const openOverlay = (e: any) => {
  trackButtonClick(e.target)
  isFilterInfoOpen.value = true
}

const cellClasses =
  'border-t-2 border-l-2 first:border-l-0 py-2 px-3 border-white align-top'

const infoTable = computed(() => {
  return [...props.filter.values]
    .sort((a: any, b: any) => b.handle - a.handle) // sort by handle desc
    .map((item: any) => {
      const cat = item.handle
      const i18nKey = `${i18nRoot}.cat${cat}`
      return {
        cat,
        tint: $i18n.t(`${i18nKey}_label`),
        application: $i18n.t(`${i18nKey}_text`),
        warning: $i18n.te(`${i18nKey}_warning`)
          ? $i18n.t(`${i18nKey}_warning`)
          : undefined,
      }
    })
})
</script>
